export const SUBSCRIPTION_PAYMENT_FORM_PATH = '/profile/subscription/payment-form'
